import {default as VtxInput} from './stateInput';
import {default as VtxSelect, Option, OptGroup} from './stateSelect';

let VtxForm = {
    VtxInput,
    VtxSelect, 
    Option, 
    OptGroup
}

export default VtxForm;
export {VtxInput,VtxSelect, Option, OptGroup};